export enum BetslipActionButtonTracking {
    NotApplicable = 'not applicable',
    Betslip = 'Betslip',
    QuickBet = 'QuickBet',
    EditMyBet = 'Edit My Bet',
    PlaceBet = 'Place bet',
    PlaceFreeBet = 'Place free bet',
    AcceptChanges = 'Accept changes',
    AcceptAndPlace = 'Accept&place bet',
    AcceptAndPlaceFreeBet = 'Accept&place freebet',
    LoginToBet = 'Login to bet',
    MakeDeposit = 'Make a deposit',
    Deposit = 'Deposit',
    DepositAndPlace = 'Deposit&place bet',
    Confirm = 'Confirm',
    SaveChanges = 'Save changes',
}

export enum BetslipLinearTracking {
    NotApplicable = 'not applicable',
    Betslip = 'Betslip',
    FullBetslip = 'full betslip',
    Click = 'click',
    LinearCheckbox = 'linear checkbox',
    LinearNoCheckbox = 'linear no checkbox',
    Tabbed = 'tabbed',
    Combo = 'combo bet',
    Single = 'single bet',
    System = 'system bet',
    Teaser = 'teaser bet',
    EditBet = 'edit bet',
    Load = 'load',
    Icon = 'Icon',
    BetBuilder = 'betbuilder bet',
    SuccessMessage = 'success message',
    AddPromo = 'add promo',
    PromotionsPopup = 'rewards popup/active promotions',
    Close = 'close',
    SettingsIcon = 'settings icon',
    Settings = 'betslip settings',
    SettingsPopup = 'settings popup',
}

export enum LinearCtaTrackingType {
    CloseCta = 'close cta',
    DepositCta = 'deposit cta',
}

export enum PickBetTrackingTypes {
    Single = 'single',
    Parlay = 'parlay',
    Sgp = 'sgp',
    SgpPlus = 'sgp+',
    Teaser = 'teaser',
    System = 'system',
}

export enum InfoTrackingContext {
    ComboBet = 'combo bet',
    Sgp = 'sgp',
    SgpPlus = 'sgp+',
    SystemBet = 'system bet',
    TeaserBet = 'teaser bet',
}

export enum LinearCheckboxTrackingState {
    Selected = 'selected',
    Unselected = 'unselected',
}

export enum LinearModuleExpansionTrackingState {
    Expand = 'expand',
    Collapse = 'collapse',
}

export const BetslipTrackingLocation = 'Betslip';
export const LinearBetslipTrackingLocation = 'linear';
export const QuickBetTrackingLocation = 'Quick Bet';
